module.exports = __webpack_public_path__ + "static/img/des2.6c013e3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/des2.png
// module id = /dDR
// module chunks = 0